import React from "react";

const ReviewBottomLine = React.memo(({ totals, scores, setScores, filters }) => {

  const toggleScores = (score) => {
    let currentScores = [...scores]
    if(currentScores.indexOf(score) > -1){
      currentScores = currentScores.filter((currentScore) => currentScore != score);
    }else{
      currentScores.push(score);
    }
    setScores(currentScores);
  }

  const loading = (totals[1] && totals[2] && totals[3] && totals[4] && totals[5] && totals.all) ? false : true;

  var percentage1 = !loading ? (totals[1] / totals.all * 100).toFixed() : null;
  var percentage2 = !loading ? (totals[2] / totals.all * 100).toFixed() : null;
  var percentage3 = !loading ? (totals[3] / totals.all * 100).toFixed() : null;
  var percentage4 = !loading ? (totals[4] / totals.all * 100).toFixed() : null;
  var percentage5 = !loading ? (totals[5] / totals.all * 100).toFixed() : null;

  var avarage = !loading ? (totals[1] + (2 * totals[2]) + (3 * totals[3]) + (4 * totals[4]) + (5 * totals[5])) / totals.all : 5;

  return <div className="yotpo__bottom-line">
    <div className="yotpo__bottom-line__item yotpo__average">
      <div className={`yotpo__average__number h3 ${loading ? "loading" : ""}`}>{avarage.toFixed(2)} / 5</div>
      <div className={`yotpo__average__summary ${loading ? "loading" : ""}`}>
        <div className="reviews-highlight__reviews-stars" style={{"--percentage": `${(avarage / 5 * 100).toFixed()}%`}}></div>
        <div className="yotpo__average__total">{totals.all} Reviews</div>
      </div>
    </div>
    <div className="yotpo__bottom-line__item yotpo__histogram">
      <div className={`yotpo__histogram__bar-container yotpo__histogram__5 ${(scores.length == 0 || scores.indexOf(5)) > -1 ? "" : "yotpo__histogram__bar-container--muted"}`} onClick={() => toggleScores(5)}>
        <div className="reviews-highlight__reviews-stars" style={{"--percentage": `100%`}}></div>
        <div className={`yotpo__histogram__bar ${typeof percentage5 == 'number' ? 'loading' : ''}`} style={{"--percentage": `${percentage5 || 0}%`}}></div>
      </div>
      <div className={`yotpo__histogram__bar-container yotpo__histogram__4 ${(scores.length == 0 || scores.indexOf(4)) > -1 ? "" : "yotpo__histogram__bar-container--muted"}`} onClick={() => toggleScores(4)}>
        <div className="reviews-highlight__reviews-stars" style={{"--percentage": `80%`}}></div>
        <div className={`yotpo__histogram__bar ${typeof percentage4 == 'number' ? 'loading' : ''}`} style={{"--percentage": `${percentage4 || 0}%`}}></div>
      </div>
      <div className={`yotpo__histogram__bar-container yotpo__histogram__3 ${(scores.length == 0 || scores.indexOf(3)) > -1 ? "" : "yotpo__histogram__bar-container--muted"}`} onClick={() => toggleScores(3)}>
        <div className="reviews-highlight__reviews-stars" style={{"--percentage": `60%`}}></div>
        <div className={`yotpo__histogram__bar ${typeof percentage3 == 'number' ? 'loading' : ''}`} style={{"--percentage": `${percentage3 || 0}%`}}></div>
      </div>
      <div className={`yotpo__histogram__bar-container yotpo__histogram__2 ${(scores.length == 0 || scores.indexOf(2)) > -1 ? "" : "yotpo__histogram__bar-container--muted"}`} onClick={() => toggleScores(2)}>
        <div className="reviews-highlight__reviews-stars" style={{"--percentage": `40%`}}></div>
        <div className={`yotpo__histogram__bar ${typeof percentage2 == 'number' ? 'loading' : ''}`} style={{"--percentage": `${percentage2 || 0}%`}}></div>
      </div>
      <div className={`yotpo__histogram__bar-container yotpo__histogram__1 ${(scores.length == 0 || scores.indexOf(1)) > -1 ? "" : "yotpo__histogram__bar-container--muted"}`} onClick={() => toggleScores(1)}>
        <div className="reviews-highlight__reviews-stars" style={{"--percentage": `20%`}}></div>
        <div className={`yotpo__histogram__bar ${typeof percentage1 == 'number' ? 'loading' : ''}`} style={{"--percentage": `${percentage1 || 0}%`}}></div>
      </div>
    </div>
    <div className="yotpo__bottom-line__item yotpo__filters">
      {filters}
    </div>
  </div>;

});

export default ReviewBottomLine;
